import { Observable, Subject } from "rxjs";
import { first, map } from "rxjs/operators";
import { IDefaultAddress } from "../interfaces/IDefaultAddress";
import { IShoppingLocationForm } from "../interfaces/IShoppingLocationForm";
import { IAddress } from "./../interfaces/IAddress";
import { IShoppingLocation } from "./../interfaces/IShoppingLocation";
import ApiCacheService from "./apiCacheService";
import { ApiEndpointResolver, IsEcom } from "./apiEndpointResolver";
import EnvironmentService from "./environmentService";
import HttpClient from "./httpClient";
import SessionCacheService from "./sessionCacheService";
import { WbmMainHeaderApi } from "@wbmason/main-header-api";

export const AddressesService = {
  getDeliveryAddresses(): Observable<IAddress[]> {
    return ApiCacheService.withCache(
      "Shipping",
      HttpClient.get<IAddress[]>({
        baseUri: ApiEndpointResolver.getDeliveryAddressesUrl(),
      }).pipe(
        map((addresses) => {
          if (addresses) {
            addresses.forEach((a) => {
              a.id = a.id.toString();
            });
          }

          return addresses;
        }),
      ),
    );
  },
  /** Clears the cached delivery addresses */
  clearDeliveryAddressesCache(): void {
    ApiCacheService.clear("Shipping");
  },
  /** Clears the cached shopping location */
  clearShoppingLocationCache(): void {
    if (typeof sessionStorage !== "undefined") {
      Object.keys(sessionStorage).forEach((key) => {
        if (key.includes("SelectedAddressNew")) {
          sessionStorage.removeItem(key);
        }
      });
    }
  },
  setShoppingLocation(
    defaultAddress: IDefaultAddress,
  ): Observable<IShoppingLocation> {
    if (!IsEcom() || EnvironmentService.get().setShoppingLocationUrl) {
      defaultAddress.addressRecId = parseInt(
        defaultAddress.addressRecId as string,
      );
    }

    return HttpClient.post(
      {
        baseUri: ApiEndpointResolver.setShoppingLocationUrl(),
        body: defaultAddress,
      },
      {
        withCredentials: true,
      },
    );
  },
  getShoppingLocationByZipCode(zipCode: string, registrationType: string) {
    return HttpClient.get<IShoppingLocation>(
      {
        baseUri: ApiEndpointResolver.getShoppingLocationByZipCode(
          zipCode,
          registrationType,
        ),
      },
      {
        withCredentials: true,
      },
    );
  },
  getShoppingLocation(): Observable<IShoppingLocation> {
    let shoppingLocationSubject = new Subject<IShoppingLocation>();

    SessionCacheService.get(
      "SelectedAddressNew",
      HttpClient.get<IShoppingLocation>({
        baseUri: ApiEndpointResolver.getShoppingLocationUrl(),
      }),
      (shoppingLocation) => {
        shoppingLocationSubject.next(shoppingLocation);
      },
      (error: any) => {
        shoppingLocationSubject.error(error);
      },
    );

    return shoppingLocationSubject.asObservable();
  },
  getAddressFromRegCookie(): Observable<IShoppingLocationForm> {
    if (IsEcom()) {
      return WbmMainHeaderApi.getShoppingLocation().pipe(
        first(),
        map((value) => {
          const address: IShoppingLocationForm = {
            registrationType: 0, // todo
            zipCode: value.zipCode,
          };

          return address;
        }),
      );
    }

    return HttpClient.get(
      {
        baseUri: ApiEndpointResolver.getAddressFromRegCookieUrl(),
      },
      {
        withCredentials: true,
      },
    );
  },
};
